var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-image",style:(("background-image: url(https://storage.googleapis.com/emma-static/products/" + _vm.path + "_1200.jpg)"))})}
var staticRenderFns = []

export { render, staticRenderFns }